import type { HTMLAttributes, ReactNode } from 'react';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

/**
 * The single most-repeated container in the app. Flat surface + subtle
 * border — deliberately no shadow. docs/DESIGN_SYSTEM.md §4.5 / §3.3.
 */
export function Card({ children, className = '', ...props }: CardProps) {
  return (
    <div
      className={['bg-bg-surface border border-border-subtle rounded-md p-5', className].join(
        ' ',
      )}
      {...props}
    >
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: ReactNode;
  description?: ReactNode;
  action?: ReactNode;
}

export function CardHeader({ title, description, action }: CardHeaderProps) {
  return (
    <div className="flex items-start justify-between gap-4 mb-4">
      <div>
        <h3 className="text-h3 text-text-primary">{title}</h3>
        {description ? <p className="text-small text-text-secondary mt-1">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  );
}
